import React from 'react';
import { motion } from 'framer-motion';
import { TestimonialCard } from './TestimonialCard';
const testimonials = [{
  quote: 'Me recordó todo lo que hacía mi abuela. Y funciona de verdad.',
  author: 'Mariana',
  age: 42
}, {
  quote: 'Lo tengo guardado en el celular. Siempre vuelvo cuando necesito algo.',
  author: 'Laura',
  age: 36
}, {
  quote: 'Dejé de depender de productos caros para cosas simples.',
  author: 'Ana',
  age: 51
}];
export function TestimonialsSection() {
  return <section className="py-20 bg-white px-4 sm:px-6 lg:px-8" data-id="element-171">
      <div className="max-w-6xl mx-auto" data-id="element-172">
        <h2 className="text-3xl font-serif font-bold text-center text-[#5C4033] mb-12" data-id="element-173">
          Lo que dicen nuestras lectoras
        </h2>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-174">
          {testimonials.map((t, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: i * 0.2
        }} data-id="element-175">
              <TestimonialCard {...t} data-id="element-176" />
            </motion.div>)}
        </div>
      </div>
    </section>;
}